import React from 'react';

import styles from './index.module.css';

export default function XcopriIsi({}) {
  return (
    <div className='container '>
      <div className='row'>
        <div className='col'>
          <p className={`${styles.isi_title}`}>
            IMPORTANT SAFETY INFORMATION and INDICATION for XCOPRI® (cenobamate tablets) CV
          </p>
          <div className={`${styles.isi_body}`}>
            <b>DO NOT TAKE XCOPRI IF YOU:</b>
            <br />
            <ol className={`${styles.isi_body_list}`}>
              <li className={`${styles.isi_body}`}>
                Are allergic to cenobamate or any of the other ingredients in XCOPRI.
              </li>
              <li className={`${styles.isi_body}`}>
                Have a genetic problem (called Familial Short QT syndrome) that affects the electrical system of the
                heart.
              </li>
            </ol>
          </div>
          <p className={`${styles.isi_body}`}>
            <b>XCOPRI CAN CAUSE SERIOUS SIDE EFFECTS, INCLUDING:</b>
            <br />
            <b>
              Allergic reactions: XCOPRI can cause serious or life threatening skin rash or other serious allergic
              reactions which may affect organs and other parts of your body like the liver or blood cells.
            </b>{' '}
            You may or may not have a rash with these types of reactions. Call your healthcare provider right away and
            go to the nearest emergency room if you have any of the following: swelling of your face, eyes, lips, or
            tongue, trouble swallowing or breathing, a skin rash, hives, fever, swollen glands, or sore throat that does
            not go away or comes and goes, painful sores in the mouth or around your eyes, yellowing of your skin or
            eyes, unusual bruising or bleeding, severe fatigue or weakness, severe muscle pain, frequent infections, or
            infections that do not go away.{' '}
            <b>
              Take XCOPRI exactly as your healthcare provider tells you to take it. It is very important to increase
              your dose of XCOPRI slowly, as instructed by your healthcare provider.
            </b>
          </p>
          <p className={`${styles.isi_body}`}>
            <b>QT shortening: XCOPRI may cause problems with the electrical system of the heart (QT shortening).</b>{' '}
            Call your healthcare provider if you have symptoms of QT shortening including fast heartbeat (heart
            palpitations) that last a long time or fainting.
          </p>
          <p className={`${styles.isi_body}`}>
            <b>Suicidal behavior and ideation:</b> Antiepileptic drugs, including XCOPRI, may cause suicidal thoughts or
            actions in a very small number of people, about 1 in 500. Call your health care provider right away if you
            have any of the following symptoms, especially if they are new, worse, or worry you: thoughts about suicide
            or dying; attempting to commit suicide; new or worse depression, anxiety, or irritability; feeling agitated
            or restless; panic attacks; trouble sleeping (insomnia); acting aggressive; being angry or violent; acting
            on dangerous impulses; an extreme increase in activity and talking (mania); or other unusual changes in
            behavior or mood
          </p>
          <p className={`${styles.isi_body}`}>
            <b>Liver problems:</b> XCOPRI may cause liver problems. Your healthcare provider will do blood tests to
            check your liver before you start XCOPRI and while you take XCOPRI if needed. Tell your healthcare provider
            right away if you have any symptoms of liver problems, such as: yellowing of the skin and eyes (jaundice),
            nausea, vomiting, unusual darkening of the urine, or feeling tired or weak.
          </p>
          <p className={`${styles.isi_body}`}>
            <b>Nervous system problems:</b> XCOPRI may cause problems that affect your nervous system. Symptoms of
            nervous system problems include: dizziness, trouble walking or with coordination, feeling sleepy and tired,
            trouble concentrating, remembering, and thinking clearly, and vision problems.{' '}
            <b>
              Do not drive, operate heavy machinery, or do other dangerous activities until you know how XCOPRI affects
              you.
            </b>
          </p>
          <p className={`${styles.isi_body}`}>
            <b>
              Do not drink alcohol or take other medicines that can make you sleepy or dizzy while taking XCOPRI without
              first talking to your healthcare provider.
            </b>
          </p>
          <p className={`${styles.isi_body}`}>
            <b>DISCONTINUATION:</b>
            <br />
            <b>Do not stop taking XCOPRI without first talking to your healthcare provider.</b> Stopping XCOPRI suddenly
            can cause serious problems. Stopping seizure medicine suddenly in a patient who has epilepsy can cause
            seizures that will not stop (status epilepticus).
          </p>
          <p className={`${styles.isi_body}`}>
            <b>DRUG INTERACTIONS:</b>
            <br />
            XCOPRI may affect the way other medicines work, and other medicines may affect how XCOPRI works.{' '}
            <b>Do not start or stop other medicines without talking to your healthcare provider.</b> Tell healthcare
            providers about all the medicines you take, including prescription and over-the-counter medicines, vitamins
            and herbal supplements.
          </p>
          <p className={`${styles.isi_body}`}>
            <b>PREGNANCY AND LACTATION:</b>XCOPRI may cause your birth control medicine to be less effective.{' '}
            <b>Talk to your healthcare provider about the best birth control method to use.</b>
          </p>
          <p className={`${styles.isi_body}`}>
            <b>Talk to your health care provider if you are pregnant or plan to become pregnant.</b> It is not known if
            XCOPRI will harm your unborn baby. Tell your healthcare provider right away if you become pregnant while
            taking XCOPRI. You and your healthcare provider will decide if you should take XCOPRI while you are
            pregnant. If you become pregnant while taking XCOPRI, talk to your healthcare provider about registering
            with the North American Antiepileptic Drug (NAAED) Pregnancy Registry. The purpose of this registry is to
            collect information about the safety of antiepileptic medicine during pregnancy. You can enroll in this
            registry by calling 1-888-233-2334 or go to{' '}
            <a href='https://www.aedpregnancyregistry.org' target='_blank'>
              www.aedpregnancyregistry.org
            </a>
          </p>
          <p className={`${styles.isi_body}`}>
            <b>Talk to your health care provider if you are breastfeeding or plan to breastfeed.</b> It is not known if
            XCOPRI passes into breastmilk. Talk to your healthcare provider about the best way to feed your baby while
            taking XCOPRI.
          </p>
          <p className={`${styles.isi_body}`}>
            <b>COMMON SIDE EFFECTS:</b>
            <br />
            The most common side effects in patients taking XCOPRI include dizziness, sleepiness, headache, double
            vision, and feeling tired.
          </p>
          <p className={`${styles.isi_body}`}>
            These are not all the possible side effects of XCOPRI. Tell your healthcare provider if you have any side
            effect that bothers you or that does not go away. For more information, ask your healthcare provider or
            pharmacist.{' '}
            <b>
              Call your doctor for medical advice about side effects. You may report side effects to FDA at
              1-800-FDA-1088
            </b>{' '}
            or{' '}
            <a href='https://www.fda.gov/medwatch' target='_blank'>
              www.fda.gov/medwatch.
            </a>
          </p>
          <p className={`${styles.isi_body}`}>
            <b>DRUG ABUSE:</b>
            <br />
            <b>XCOPRI is a federally controlled substance (CV) because it can be abused or lead to dependence.</b> Keep
            XCOPRI in a safe place to prevent misuse and abuse. Selling or giving away XCOPRI may harm others and is
            against the law.
          </p>
          <p className={`${styles.isi_body}`}>
            <b>INDICATION:</b>
            <br />
            XCOPRI is a prescription medicine used to treat partial-onset seizures in adults.
          </p>
          <p className={`${styles.isi_body}`}>
            Please see additional patient information in the{' '}
            <a href='https://www.xcopri.com/pdf_file/xcopri_cenobamate_medication_guide_8-2025.pdf' target='_blank'>
              Medication Guide
            </a>{' '}
            This information does not take the place of talking with your healthcare provider about your condition or
            your treatment.
          </p>
          <p className={`${styles.isi_body}`}>
            Please see full{' '}
            <a
              href='https://www.xcopri.com/pdf_file/xcopri_cenobamate_prescribing_information_medication_guide_combined.pdf'
              target='_blank'
            >
              Prescribing Information
            </a>{' '}
            and{' '}
            <a href='https://www.xcopri.com/pdf_file/xcopri_cenobamate_medication_guide_8-2025.pdf' target='_blank'>
              Medication Guide.
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
